// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"e5acaedb","486":"d62c84f3","510":"bab052c8","636":"2e348e65","688":"abe761d9","721":"a443d7a0","787":"2a659ee2"}[chunkId] + ".chunk.js";
};